import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAlert = styled(UIAlert).withConfig({
  displayName: "RussianBlockedBanner__StyledAlert",
  componentId: "sc-16wvlmi-0"
})(["max-width:1400px;margin:0 auto;"]);
const RussianBlockedBanner = () => {
  const isRussianBlocked = useSelector(isRussianBlockedSelector);
  if (!isRussianBlocked) return null;
  return /*#__PURE__*/_jsx(StyledAlert, {
    type: "danger",
    className: "m-bottom-2",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "russianBlocked.alert.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "russianBlocked.alert.body"
    })
  });
};
export default RussianBlockedBanner;